import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import AppHeader from "@/components/AppHeader";
import ReportView from "@/components/ReportView";
import { Button } from "@/components/ui/button";
import { Loader2, ArrowLeft } from "lucide-react";

export default function ReportPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/reports/${id}`).then((r) => setReport(r.data)).catch(() => setError(true));
  }, [id]);

  return (
    <div className="min-h-screen bg-background">
      <AppHeader />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10">
        <Button variant="ghost" className="rounded-full mb-6 text-muted-foreground hover:text-primary" onClick={() => navigate(-1)} data-testid="report-back-btn"><ArrowLeft size={16} strokeWidth={1.5} /> Back</Button>
        {error ? (
          <p className="text-muted-foreground">Report not found.</p>
        ) : report ? (
          <ReportView report={report} />
        ) : (
          <div className="py-24 grid place-items-center"><Loader2 className="animate-spin text-primary" strokeWidth={1.5} /></div>
        )}
      </div>
    </div>
  );
}
